//export const baseURL = "http://localhost:8080";
//export const baseURL = "https://vt-backend.vercel.app";
export const baseURL = "https://backend.villatracker.com";
//export const ShubURL = "https://api.villatracker.com";
//export const ShubURL = "http://localhost:3333";
export const ShubAuth = "__HUB_SESSION__"

